import { http, HttpResponse } from 'msw'
import { UnsecuredJWT } from 'jose'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { AuthTokens } from 'app/types/auth/login'
import { ResetPasswordPayload } from 'app/types/auth/resetPassword'

export const resetPassword = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.CONFIRM_RESET_PASSWORD}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ResetPasswordPayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const accessToken = new UnsecuredJWT()
            .setIssuedAt()
            .setExpirationTime('1d')
            .encode()

        const refreshToken = new UnsecuredJWT()
            .setIssuedAt()
            .setExpirationTime('15d')
            .encode()

        return HttpResponse.json<AuthTokens>({
            access: accessToken,
            refresh: refreshToken,
        })
    },
)
